
export const getSeverity = (status) => {
    return status ? 'success' : 'danger';
};